var _excluded = ["children", "onClick"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef } from "react";
import { node, func } from "prop-types";
import { MenuItem } from "#library/components/Menu/MenuItem";
import { Icon } from "#library/components/Icon/Icon";
import { DATA_SPACER } from "#library/constants/enums";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
import { hideDropdownMenu, setTriggerButton, showDropdownMenu } from "#library/components/Dropdown/Dropdown.actions";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
export var TriggerMenuItem = function TriggerMenuItem(props) {
  var children = props.children,
    onClick = props.onClick,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var triggerRef = useRef();
  useEffect(function () {
    var triggerButton = triggerRef.current;
    dispatch(setTriggerButton(triggerButton));
  }, [dispatch]);
  var toggleDropdownMenu = function toggleDropdownMenu(event) {
    if (state.isDropdownMenuVisible) {
      dispatch(hideDropdownMenu());
    } else {
      dispatch(showDropdownMenu());
    }
    onClick(event, state);
  };
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    "aria-expanded": state.isDropdownMenuVisible,
    "aria-haspopup": "true"
  }, restProps, {
    as: "button",
    onClick: toggleDropdownMenu,
    ref: triggerRef
  }), children, /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(IconArrowDown.id),
    dataSpacer: DATA_SPACER.LEFT_50
  }));
};
TriggerMenuItem.propTypes = {
  children: node.isRequired,
  onClick: func
};
TriggerMenuItem.defaultProps = {
  onClick: function onClick() {}
};